import { mapGetters } from 'vuex'

import pendingAuthActions from '@/utils/mixins/pending-auth-actions'
import { MODAL } from 'modals/AModalWrapper'
import {
  ACTIVATOR_ID,
  ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID
} from 'enums/activator-id'

export const ACTION_QUERY_PARAM = {
  OPEN_AUTH_FORM: 'openAuthForm',
  OPEN_NEWSLETTER_FORM: 'openNewsletterForm'
}

export default {
  mixins: [pendingAuthActions],
  data() {
    return {
      actionsByQueryParams: {
        [ACTION_QUERY_PARAM.OPEN_AUTH_FORM]: this
          .$_actionsOnQueryParams_openAuthModal,
        [ACTION_QUERY_PARAM.OPEN_NEWSLETTER_FORM]: this
          .$_actionsOnQueryParams_openNewsletterModal
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    })
  },
  watch: {
    '$route.query'() {
      this.$_actionsOnQueryParams_handleQueryParams()
    }
  },
  methods: {
    $_actionsOnQueryParams_handleQueryParams() {
      Object.keys(this.actionsByQueryParams).forEach(queryParam => {
        const queryParamLowerCased = queryParam.toLowerCase()
        const queryParamsLowerCased = this.$helper.valuesToLowercase(
          Object.keys(this.$route.query || {})
        )
        if (queryParamsLowerCased.includes(queryParamLowerCased)) {
          requestAnimationFrame(this.actionsByQueryParams[queryParam])
        }
      })
    },
    async $_actionsOnQueryParams_openAuthModal() {
      await this.$_pendingAuthActions_waitForAuthStatusIsReceived()
      if (this.isLoggedIn) return

      this.$helper.openModal(MODAL.AUTH_FORM, {
        activatorSelector: ACTIVATOR_SELECTOR_BY_ACTIVATOR_ID[ACTIVATOR_ID.AUTH]
      })
    },
    $_actionsOnQueryParams_openNewsletterModal() {
      this.$helper.openModal(MODAL.NEWSLETTER_FORM)
    }
  },
  mounted() {
    this.$_actionsOnQueryParams_handleQueryParams()
  }
}
